export default __webpack_public_path__ + "static/media/1978.4c252537.png";